import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BarCodeCategory, LocalService, PageKey, Status } from '../../../service/local.service';
import { MenuManagementService } from 'src/service/menu-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {
  path = ''; shortenUrl = ''; dpath: string = '';
  constructor(public localService: LocalService, private route: ActivatedRoute, private router: Router, private configurationManagementService: ConfigurationManagementService, private menuManagementService: MenuManagementService) {
    this.dpath = this.route.snapshot.queryParamMap.get('dpath');
  }
  isRequeCheckInitiated = false;

  ngOnInit(): void {
    if (this.dpath && this.dpath.length > 0) {
      this.router.navigate(['/' + this.dpath]);
    } else {
      this.route.params.subscribe(routeParams => {
        this.shortenUrl = routeParams.shortenUrl;
        this.path = routeParams.path;
        if (!this.localService.reques) {
          this.onCheckReques();
        } else {
          this.onInitiate();
        }
      });
    }
  }

  onCheckReques() {
    if (!this.isRequeCheckInitiated) {
      this.isRequeCheckInitiated = true;
      if (!this.localService.reques) {
        this.configurationManagementService.getReques().subscribe(result => {
          if (result && result.status == Status.Success) {
            this.localService.reques = this.localService.decryptCrypto(result.value, environment.ui);
            this.onInitiate();
          }
        });
      } else {
        this.onInitiate();
      }
    } else {
      this.onInitiate();
    }
  }

  onInitiate() {
    if (this.shortenUrl) {
      this.menuManagementService.getShortenUrl(this.shortenUrl).subscribe(result => {
        if (result.status == Status.Success) {
          this.router.navigate(['/' + result.value]);
        } else {
          this.router.navigate(['']);
        }
      });
    } else {
      setTimeout(() => {
        const decodedQrCode = this.localService.getDecodedQrCode('rdir/' + this.path);
        if (decodedQrCode.isValid) {
          if (decodedQrCode.barCodeCategory == BarCodeCategory.Billing && !this.localService.selected.user) {
            this.router.navigate(['/rv', decodedQrCode.countryCode, decodedQrCode.value]);
          } else {
            this.localService.redirectUrl = 'rdir/' + this.path;
            this.localService.navigateToPage = this.localService.redirectUrl.startsWith(this.localService.barCodePrefix) ? PageKey.QrCode : PageKey.None;
          }
        } else {
          this.router.navigate(['']);
        }
      }, 500);
    }
  }
}
